import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";

import { RouteLink, StyledAnchor } from "@/components/common/styles";
import { ACCENT_DEEP } from "@/components/marketing/tokens";
import { BLOG_HREF } from "./navigation";

/**
 * The published header marks the menu entry for the page you are on in the
 * accent's dark step. `/blog` is the one menu entry inside this component's own
 * route tree, so it is the only one that can be a typed client-side link and
 * the only one that can be current; the rest, including the surfaces this app
 * does serve from other trees, cross a tree boundary and stay plain anchors.
 */
const CURRENT = { style: { color: ACCENT_DEEP } };

export default function NavAnchor({
  href,
  sx,
  onNavigate,
  children,
}: {
  href: string;
  sx?: SxProps<Theme>;
  onNavigate?: () => void;
  children: ReactNode;
}) {
  if (href === BLOG_HREF) {
    return (
      <RouteLink
        to={BLOG_HREF}
        activeProps={CURRENT}
        sx={sx}
        onClick={onNavigate}
      >
        {children}
      </RouteLink>
    );
  }
  return (
    <StyledAnchor href={href} sx={sx} onClick={onNavigate}>
      {children}
    </StyledAnchor>
  );
}
